import { Component, OnInit, Input, SimpleChanges, ViewChild } from "@angular/core";
import { IonSlides, Platform } from "@ionic/angular";
import { LanguagesService } from "src/app/services/languagesService/languages.service";

@Component({
  selector: "app-outstanding-content",
  templateUrl: "./outstanding-content.component.html",
  styleUrls: ["./outstanding-content.component.scss"],
})
export class OutstandingContentComponent implements OnInit {
  @ViewChild(IonSlides) slides: IonSlides;

  @Input() newsPost: [];
  optionSelected = "newsPost";
  slidesContentPerView: number = 1.5;
  
  slideOpts = {};

  constructor(
    private languageService: LanguagesService,
    public platform: Platform
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    // console.log("++",changes);
    if (changes.newsPost && changes.newsPost.currentValue !== undefined) {
      let changesPost =  this.newsPost.filter((x:any)=> x.Publish)
      console.log("___changesPost",changesPost);
       this.slidesOptsF(changesPost)
    }
  }

  slidesOptsF(data?: any){
    if (this.platform.is("desktop")) {
      this.slidesContentPerView = 3;
    }
    this.slideOpts = {
      spaceBetween: 1,
      initialSlide: 0,
      speed: 400,
      slidesPerView:  window.screen.width > 768 ? 3: 2,
      autoplay: false,
      loop: data?.length > 1 ? true : false
    };
  }

  ngOnInit() {
    this.slidesOptsF();
  }

  slidePrev() {
    this.slides.slidePrev();
  }

  slideNext() {
    this.slides.slideNext();
  }

  onClick(event: any) {
    this.optionSelected = event;
  }

  get getTextsIUContent() {
    return this.languageService.textsIU.page_content;
  }
}